<template>
	<j-card class="p4 bg5">
		<div class="flex xs-12 xs-between xs-middle mb4">
			<!-- Name of checklist -->
			<div
				class="fs5 fw7 c6"
				@click="showEditNameInput = true"
				v-if="!showEditNameInput"
			>{{ nameText }}</div>
			<j-base-input-long-text
				:rows="2"
				class="xs"
				v-if="showEditNameInput"
				v-model="nameText"
				@blur="updateName"
				size="small"
				v-focus
			/>
		</div>

		<div>
			<checklist-item
				v-for="(item, i) in list"
				:key="i"
				class="mt4"
				:value="item.label"
				:isTicked="item.isTicked"
				@update:checkbox="updateCheckbox({index: i, value: $event})"
				@update:label="updateLabel({index: i, value: $event})"
				@delete:item="deleteItem(i)"
			/>

			<div
				v-if="!showAddTextInput"
				class="fs4 c6 bc7 b1 p2 mt4 cu2"
				@click="showAddTextInput = true"
			>{{ $t("add_item") }}</div>

			<j-base-input-long-text
				v-if="showAddTextInput"
				v-model="addText"
				v-validate="'required'"
				:rows="3"
				class="mt4"
				v-focus
			/>
			<div class="flex xs-12 mt2" v-if="showAddTextInput">
				<j-button @click="addItem" class="mr1" size="xsmall">{{ $t("add_item") }}</j-button>
				<j-button
					@click="showAddTextInput = false"
					type="secondary"
					size="xsmall"
				>{{ $t("close") }}</j-button>
			</div>
		</div>

		<div class="flex xs-12 xs-right bc7 bt1 mt4">
			<!-- Delete Checklist -->
			<j-button
				class="mt4"
				size="small"
				type="error"
				@click="$emit('deleted', payload.id)"
			>{{ $t("delete") }}</j-button>
		</div>
	</j-card>
</template>

<script>
import ChecklistItem from "./ChecklistItem"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon/"
import JBaseInputLongText from "@/components/JBaseInputLongText/"

export default {
	components: {
		ChecklistItem,
		JCard,
		JButton,
		CrmIcon,
		JBaseInputLongText
	},

	props: {
		payload: {
			type: Object
		}
	},

	data() {
		return {
			list: [],
			showAddTextInput: false,
			addText: null,

			showEditNameInput: false,
			nameText: null
		}
	},

	watch: {
		payload: {
			handler() {
				this.list = this.payload?.value?.arrayValue?.map(item => {
					const parsedObj = JSON.parse(item?.stringValue)
					return {
						label: parsedObj?.label,
						isTicked: parsedObj?.isTicked
					}
				})
				this.nameText = this.payload?.type?.split("checklist-")?.[1]
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		updateCheckbox({ index, value }) {
			this.list[index].isTicked = value
			this.$emit("updated", {
				id: this.payload.id,
				list: this.list,
				name: this.nameText
			})
		},
		updateLabel({ index, value }) {
			this.list[index].label = value
			this.$emit("updated", {
				id: this.payload.id,
				list: this.list,
				name: this.nameText
			})
		},
		updateName() {
			this.$emit("updated", {
				id: this.payload.id,
				list: this.list,
				name: this.nameText
			})
			this.showEditNameInput = false
		},
		async addItem() {
			const isValid = await this.$validator.validate()
			if (!isValid) return
			this.list.push({ isTicked: false, label: this.addText })
			this.$emit("updated", {
				id: this.payload.id,
				list: this.list,
				name: this.nameText
			})
			this.showAddTextInput = false
			this.addText = null
		},
		deleteItem(index) {
			this.list.splice(index, 1)
			this.$emit("updated", {
				id: this.payload.id,
				list: this.list,
				name: this.nameText
			})
		}
	},

	directives: {
		// auto focus on JBaseInputLongText
		focus: {
			inserted: function(el) {
				el.focus()
			}
		}
	}
}
</script>
